import { DesignTokens } from '@givelify/ui';
import { LinearProgress, linearProgressClasses } from '@mui/material';
import { styled } from '@mui/material/styles';
import { GivelifyLabel } from '../label';
const LEFT_LIMIT = 15;
const RIGHT_LIMIT = 85;

export const BorderLinearProgress = styled(LinearProgress)(() => ({
    height: 8,
    borderRadius: 8,
    backgroundColor: DesignTokens.color.neutralPlatinum,
    [`& .${linearProgressClasses.bar}`]: {
        borderRadius: 8,
    },
}));

export const ProgressContainer = styled('div')({
    width: '100%',
    position: 'relative',
});

export const ProgressHeader = styled('div')({
    display: 'flex',
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 16,
});

export const ProgressFooter = styled('div', {
    shouldForwardProp: (prop) => prop !== 'position',
})<{ position: number }>(({ position }) => ({
    position: 'absolute',
    top: 16,
    left: `${
        position < LEFT_LIMIT ? 0 : position > RIGHT_LIMIT ? 100 : position
    }%`,
    transform:
        position < LEFT_LIMIT
            ? undefined
            : position > RIGHT_LIMIT
            ? 'translate(-100%, 0)'
            : 'translate(-50%, 0)',
}));

export const ProgressFooterArrow = styled('img', {
    shouldForwardProp: (prop) => prop !== 'position',
})<{ position: number }>(({ position }) => ({
    position: 'absolute',
    left: `${position < LEFT_LIMIT ? 10 : position > RIGHT_LIMIT ? 95 : 50}%`,
    top: -9,
    transform: 'translate(-50%, 0)',
}));

export const ProgressTooltipContainer = styled('div')({
    background: DesignTokens.color.backgroundComponentPrimaryDefault,
    borderRadius: 4,
    display: 'flex',
    alignItems: 'center',
    boxShadow: '0px 0px 2px rgba(0, 0, 0, 0.25)',
    padding: '4px 5px',
    whiteSpace: 'nowrap',
});

export const ProgressTooltipLabel = styled(GivelifyLabel)({
    color: DesignTokens.color.progressBarText,
});

export const ProgressTooltipDivider = styled(GivelifyLabel)({
    color: DesignTokens.color.neutralPlatinum,
    marginLeft: 3,
    marginRight: 3,
});
